import { Fragment } from 'react'
import {
  FormGroup,
  FormLabel,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
} from '@mui/material'

import InputElement from 'components/Reporting/Overview/ShareDashboard/InputElements'
import {
  formControl,
  formLabelParagraph,
  switchElements,
  textColor,
  labelPadding,
} from 'components/Reporting/Overview/ShareDashboard/StyleConstants'

type Props = {
  values: any
  loader: any
  title: string
  toggleTitle: string
  content: any
  disabledContent: any
  placeholder: string
  checked: boolean
  switchName: string
  t: any
  onChange: () => void
  handleCopyClick: ({ placeholder }: { placeholder: string }) => void
  handleSwitchUpdate: (e: any) => void
  handleClickShowPassword: () => void
}

const createContentParagraphs = (content: string[]) => {
  return content.map((item) => {
    return (
      <Fragment key={item}>
        <span>{item}</span>
        <br />
      </Fragment>
    )
  })
}

const SwitchElements = ({
  title,
  toggleTitle,
  content,
  disabledContent,
  placeholder,
  checked,
  switchName,
  values,
  loader,
  t,
  onChange,
  handleClickShowPassword,
  handleCopyClick,
}: Props) => {
  const inputElemetProps: any = ({
    placeholder,
    title,
  }: {
    placeholder: string
    title: string
  }) => ({
    t,
    placeholder,
    title,
    values,
    loader,
    handleClickShowPassword,
    handleCopyClick,
  })

  const SwitchComponent = () => (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          name={placeholder}
          onChange={onChange}
          data-testId={`data-test-${placeholder}`}
        />
      }
      label={`${toggleTitle} : ${
        switchName
          ? t('reporting.shareDetails.on')
          : t('reporting.shareDetails.off')
      }`}
      sx={{ ...formControl, ...textColor }}
    />
  )

  const ParagraphComponent = () => {
    return (
      <FormLabel id={placeholder} sx={labelPadding}>
        <p style={{ ...formLabelParagraph }}>
          {createContentParagraphs(
            !values?.['linkSwitch'] && disabledContent
              ? disabledContent
              : content,
          )}
        </p>
      </FormLabel>
    )
  }

  return (
    <Grid key={placeholder} sx={switchElements}>
      <Typography variant="body1">
        <FormGroup>
          <SwitchComponent />
          <ParagraphComponent />
          <InputElement {...inputElemetProps({ placeholder, title })} />
        </FormGroup>
      </Typography>
    </Grid>
  )
}

export default SwitchElements
